<template>
    <div>

        <vue-headful :title="`${alert.alert_name} [Training Course Alert] :: MeritEHS`"/>

        <h4 class="py-3 mb-4">
            <ol class="breadcrumb font-weight-bold m-0">
                <li class="breadcrumb-item font-weight-light">
                    <router-link :to="`/training-courses`">
                        <i class="fa fa-graduation-cap"></i> Training Courses
                    </router-link>
                </li>
                <li class="breadcrumb-item font-weight-light">
                    <router-link :to="`/training-courses/alerts`">
                        Expiring Course Alerts
                    </router-link>
                </li>
                <li class="breadcrumb-item active"><template v-if="!loading">{{ alert.alert_name }}</template></li>
            </ol>
        </h4>

        <div v-if="loading">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <div class="row">
                <div class="col-lg-8 col-12">
                    <div class="card">
                        <div class="card-header">
                            Alert Details
                            <span class="pull-right">
                                <router-link :to="`/training-courses/alerts/edit/${alert.id}`" title="Edit Email Alert" class="btn btn-sm btn-secondary">
                                    <i class="fa fa-edit"></i> Edit
                                </router-link>
                                <router-link :to="`/training-courses/alerts/delete/${alert.id}`" title="Delete Email Alert" class="btn btn-sm btn-danger">
                                    <i class="fa fa-trash"></i> Delete
                                </router-link>
                            </span>
                        </div>
                        <div class="card-body">
                            <div class="row mb-2">
                                <div class="col-md-4 text-muted">Alert Name:</div>
                                <div class="col-md-8">{{ alert.alert_name }}</div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-md-4 text-muted">Days Until Expiration:</div>
                                <div class="col-md-8">{{ alert.days_until_expires }}</div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-md-4 text-muted">Active:</div>
                                <div class="col-md-8">
                                    <label v-if="alert.is_active == 1" class="badge badge-success">Active</label>
                                    <label v-if="alert.is_active == 0" class="badge badge-warning">Inactive</label>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-md-4 text-muted">Description:</div>
                                <div class="col-md-8">{{ alert.description }}</div>
                            </div>
                        </div>
                    </div>

                    <div class="card mt-3">
                        <div class="card-header">Course Filters <small class="text-muted">If selected, only these courses will be processed by this alert</small></div>
                        <div class="card-body">
                            <ol>
                                <li v-for="(course, i) in alert.filter_on_courses" class="mb-2">
                                    <router-link :to="`/training-courses/view/${course.id}`">{{ course.course_name }}</router-link>
                                </li>
                            </ol>
                        </div>
                    </div>

                    <div class="card mt-3">
                        <div class="card-header">Recipient Rules</div>
                        <div class="card-body">
                            <ol>
                                <li v-for="(recip, key) in recipients">
                                    {{ recip.target_type }} -
                                    <template v-if="recip.target_type == 'Employee' || recip.target_type == 'User'">
                                        {{ recip.target_label.FirstName }} {{ recip.target_label.LastName }}
                                        <template v-if="recip.target_label.email"><a :href="`mailto:${recip.target_label.email}`">{{ recip.target_label.email }}</a></template>
                                        <template v-else-if="recip.target_label.Email"><a :href="`mailto:${recip.target_label.Email}`">{{ recip.target_label.Email }}</a></template>
                                        <template v-else>(No Email on Record)</template>
                                    </template>
                                    <template v-else>{{ recip.target_label }}</template>
                                </li>
                            </ol>
                        </div>
                    </div>

                    <div class="card mt-3">
                        <div class="card-header"><strong>Based on the Recipient Rules, Here are the Target Email Address:</strong></div>
                        <div class="card-body">
                            <ol>
                                <li v-for="(email, key) in emails">
                                    <a :href="`mailto:${email}`">{{ email }}</a>
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                id: this.$route.params.id,
                loading: true,
                saving: false,
                errors: {},
                alert: {},
                recipients: [],
                emails: [],
            }
        },

        methods: {
            //Load the Account
            getAlert(){
                //Send it
                this.$http.get('training-courses/alerts/view/' + this.id)
                    .then(res => {
                        //Set data
                        this.alert = res.data.alert;
                        this.recipients = this.alert.recipients;

                        //Emails
                        this.emails = res.data.emails;
                    })
                    .catch(err => {

                    })
                    .then(() => {
                        //Reset
                        this.loading = false;
                    });
            },
        },

        mounted(){
            //Get it
            this.getAlert();
        }
    }
</script>
